import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Physicianqualification, PhysicianqualificationData } from '../../../interfaces/masters/physicianqualification';
import { PhysicianqualificationApi } from '../api/physicianqualification.api';


@Injectable()
export class PhysicianqualificationService extends PhysicianqualificationData{

  constructor(private api: PhysicianqualificationApi) { 
    super();   
  }
  list(url: string): Observable<Physicianqualification[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Physicianqualification>{
      return this.api.getById(url); 
  }

  create(url: string, data:Physicianqualification): Observable<Physicianqualification> {
    return this.api.add(url,data);
  }

  update(url: string, data:Physicianqualification): Observable<Physicianqualification> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
  
}
